<template>

  <div>
    <v-card-text>

      <v-form
        ref="form"
        v-model="valid"
      >
        <v-row>
          <v-col
            cols="12"
            sm="12"
          >
            <v-text-field
              v-model.number="form.familySize"
              :rules="requireRule"
              type='number'
              :label="$t('Number of Persons Living in Household')"
              outlined
              required
            ></v-text-field>
          </v-col>
        </v-row>

        <v-text-field
          v-model.number="form.familyIncome"
          type='number'
          :rules="requireRule"
          :label="$t('Gross Wages/Salary for the family (including all sources of income) ')"
          outlined
          required
        ></v-text-field>
        <v-row>
          <v-col
            class='pt-0  pb-0'
            cols="12"
            sm="6"
          >
            <v-text-field
              v-model="signature"
              :label="$t('Signature')"
              :rules="requireRule"
            ></v-text-field>
          </v-col>
          <v-col
            class='pt-0  pb-0'
            cols="12"
            sm="6"
          >
            <v-text-field
              disabled
              v-model="today"
              :label="$t('Date')"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <p class='mt-3 font-weight-bold'>{{$t('By typing your full name above, you are signing this Agreement electronically. You agree your electronic signature is the legal equivalent of your manual signature for this application')}}
      </p>

      <h3>

        {{$t('Supporting income documentation is required with this application to be eligible for this program. Supporting documentation must be in the form of an IRS Form 1040. If an IRS Form 1040 is not available, submit a brief letter explaining your income source and why an IRS Form 1040 is not available. Additional documentation such as W-2 statements, copies of recent paychecks, and/or bank statements showing activity may be included as well.')}}

      </h3>

      <v-file-input
        @change='onFileChange'
        v-model='uploadfiles'
        chips
        multiple
        :label="$t('Upload Files here')"
      ></v-file-input>

    </v-card-text>

    <v-btn
      color="primary"
      @click="validate"
    >

      {{$t('Continue')}}

    </v-btn>
    <v-btn
      @click="currentStep = 3"
      text
    >
      {{$t('Back')}}

    </v-btn>
  </div>

</template>

<script>
import { stateList } from "../data/dataSource";
import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    today() {
      return this.$moment().format("MM-DD-YYYY");
    },
    ...mapFields([
      "form",
      "uploadId",
      "coupon",
      "currentStep",
      "selectedStateID",
      "selectedMonth",
      "selectedDate",
      "selectedGC",
      "selectedTime",
    ]),
  },
  mounted() {
    this.form.filesBase64 = [];
  },
  methods: {
    caculateCoupon() {
      let familySize = this.form.familySize;
      let totalincome = this.form.familyIncome;

      switch (familySize) {
        case 1:
          if (totalincome <= 54360) {
            return "100SAVE";
          } else {
            break;
          }
        case 2:
          if (totalincome <= 73240) {
            return "100SAVE";
          } else {
            break;
          }
        case 3:
          if (totalincome <= 92120) {
            return "100SAVE";
          }
          {
            break;
          }
        case 4:
          if (totalincome <= 111000) {
            return "100SAVE";
          } else {
            break;
          }
        case 5:
          if (totalincome <= 129880) {
            return "100SAVE";
          } else {
            break;
          }
        case 6:
          if (totalincome <= 148760) {
            return "100SAVE";
          } else {
            break;
          }
        case 7:
          if (totalincome <= 167640) {
            return "100SAVE";
          } else {
            break;
          }
        case 8:
          if (totalincome <= 186520) {
            return "100SAVE";
          } else {
            break;
          }
        default:
          if (totalincome <= familySize * 4720) {
            return "100SAVE";
          } else {
            return "";
          }
      }
    },
    async validate() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.form.coupon = this.caculateCoupon();
        this.currentStep = 5;
      }
    },
    getInsuraceState(selectedStateID) {
      return stateList().find((s) => s.stateID === selectedStateID).insuraceID;
    },
    getBase64(file, callback) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        callback(reader.result.replace("data:", "").replace(/^.+,/, ""))
      );
      reader.readAsDataURL(file);
    },
    onFileChange() {
      this.uploadfiles.forEach((file) => {
        //convert to base64
        this.getBase64(file, (base64) => {
          this.form.filesBase64.push({
            fileName: file.name,
            fileType: file.type,
            baseString: base64,
          });
        });
      });
    },
  },
  data() {
    return {
      buttonLoading: false,
      filesBase64: [],
      uploadfiles: [],
      signature: null,
      usePatient: false,
      stateList: stateList(),
      requireRule: [(v) => !!v || "This field is required"],
      valid: false,
    };
  },
};
</script>

<style>
</style>